(() => {
  const titles = {
    '/a/bundles/syn-club-circuit-+-raaw-racing-bundle-kvinde-iutl': 'SYN Club Circuit bundle - kvinde',
    '/a/bundles/syn-club-circuit-+-raaw-racing-bundle-mand-iuth': 'SYN Club Circuit bundle - mand'
  };
  const title = titles[window.location.pathname.replace(/\/$/, '')];
  if (!title) return;
  const main = document.getElementById('MainContent');
  if (!main) return;
  const updateTitle = () => {
    const heading = main.querySelector('.bndlr-bundle-title');
    if (heading && heading.textContent !== title) heading.textContent = title;
  };
  const observer = new MutationObserver(updateTitle);
  observer.observe(main, { childList: true, subtree: true, characterData: true });
  updateTitle();
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
